// src/UnsavedChangesModal.js
import React from "react";
import "./UnsavedChangesModal.css";

const UnsavedChangesModal = ({ isOpen, onConfirm, onCancel }) => {
  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape" && isOpen) {
        onCancel();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="unsaved-changes-overlay" onClick={onCancel}>
      <div
        className="unsaved-changes-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="unsaved-changes-header">
          <h3>Unsaved Changes</h3>
        </div>

        <div className="unsaved-changes-body">
          <p>You have unsaved changes. Are you sure you want to close?</p>
        </div>

        <div className="unsaved-changes-actions">
          <button className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            Discard Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
